/**
 * @generated SignedSource<<c440f69b505208ba45e5fb00d1711960>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AssignTodoModal_assignTodo_Mutation$variables = {
  id: string;
  memberId?: string | null;
};
export type AssignTodoModal_assignTodo_Mutation$data = {
  readonly assignTodo: {
    readonly todoUpdated: {
      readonly " $fragmentSpreads": FragmentRefs<"AssignTodoModal_todo" | "TodoAssignee_todo">;
    };
  } | null;
};
export type AssignTodoModal_assignTodo_Mutation = {
  response: AssignTodoModal_assignTodo_Mutation$data;
  variables: AssignTodoModal_assignTodo_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "memberId"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "memberId",
        "variableName": "memberId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AssignTodoModal_assignTodo_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodosAssignMutationPayload",
        "kind": "LinkedField",
        "name": "assignTodo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "todoUpdated",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AssignTodoModal_todo"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TodoAssignee_todo"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AssignTodoModal_assignTodo_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodosAssignMutationPayload",
        "kind": "LinkedField",
        "name": "assignTodo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Todo",
            "kind": "LinkedField",
            "name": "todoUpdated",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "FolderItem",
                "kind": "LinkedField",
                "name": "documentNode",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Member",
                "kind": "LinkedField",
                "name": "assignee",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MemberAvatar",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "roles",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AuthorizationResult",
                "kind": "LinkedField",
                "name": "canAssign",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "value",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "75fce33574496eacccc73f3af1d78e53",
    "id": null,
    "metadata": {},
    "name": "AssignTodoModal_assignTodo_Mutation",
    "operationKind": "mutation",
    "text": "mutation AssignTodoModal_assignTodo_Mutation(\n  $id: ID!\n  $memberId: ID\n) {\n  assignTodo(input: {id: $id, memberId: $memberId}) {\n    todoUpdated {\n      ...AssignTodoModal_todo\n      ...TodoAssignee_todo\n      id\n    }\n  }\n}\n\nfragment AssignTodoModal_todo on Todo {\n  id\n  documentNode {\n    space {\n      id\n    }\n    id\n  }\n  assignee {\n    id\n    name\n    ...UserHandle_member\n    ...UserAvatar_member\n  }\n}\n\nfragment TodoAssignee_todo on Todo {\n  id\n  ...AssignTodoModal_todo\n  assignee {\n    id\n    name\n    ...UserHandle_member\n    ...UserAvatar_member\n  }\n  canAssign {\n    value\n  }\n}\n\nfragment UserAvatar_member on Member {\n  name\n  email\n  avatar {\n    url\n  }\n}\n\nfragment UserHandle_member on Member {\n  id\n  name\n  email\n  ...UserAvatar_member\n  ...UserInfoPopover_member\n}\n\nfragment UserInfoPopover_member on Member {\n  id\n  name\n  email\n  roles\n  ...UserAvatar_member\n}\n"
  }
};
})();

(node as any).hash = "31661c89d0c46a5adc9eb54acc1a65b5";

export default node;
